import React from 'react';
import { observer } from 'mobx-react';
import moment from 'moment';




let ChangeAccountPanel = ({ ...props }) => {

    let redirectToHome = () => {
        props.history.push(`/`);
    }

    return (
        <button type="button" aria-label="Go Back" className="btn btn-dark" onClick={redirectToHome}>
            Change Accounts
        </button>
    )
}


ChangeAccountPanel = observer(ChangeAccountPanel)

export default ChangeAccountPanel;
